// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3F8ID","card-padding":"_3qzsJ"};